import humps from 'lodash-humps';
import { map, uniq } from 'lodash';

const state = {
    appointments: [],
    nextAppointmentInfo: null,
    gapFlag: false,
};
const getters = {
    getAppointments: state => {
        return state.appointments;
    },

    getApptsNumber: state => {
        return map(state.appointments, 'appointmentNumber');
    },

    getFirstAppointment: state => {
        return state.appointments[0]
            ? state.appointments[0]
            : null;
    },

    getAppointmentsResourceIds: state => {
        return uniq(map(state.appointments, 'resource'));
    },

    getNextAppointmentInfo: state => {
        return state.nextAppointmentInfo;
    },

    getGapFlag: state => {
        return state.gapFlag;
    },
};
const mutations = {
    SET_APPOINTMENTS(state, payload) {
        state.appointments = payload;
    },

    NEXT_APPOINTMENT_INFO(state) {
        if (state.appointments && state.appointments[0]) {
            state.nextAppointmentInfo = {
                selectedDate: state.appointments[0].start,
                selectedService: state.appointments[0].establishmentServiceTemplate,
                selectedPlace: state.appointments[0].place,
                secondAppointment: true,
            };
        }
        else {
            state.nextAppointmentInfo = null;
        }
    },

    REMOVE_NEXT_APPOINTMENT_INFO(state) {
        state.nextAppointmentInfo = null;
    },

    UPDATE_GAP_FLAG(state, payload) {
        state.gapFlag = payload;
    },
};

const actions = {
    /**
     * @description Call to the API for creating a new appointment
     * @param state
     * @param commit
     * @param rootGetters
     * @param dispatch
     * @param payload
     * @returns {Q.Promise<never>}
     */
    async createAppt({ state, commit, rootGetters, dispatch }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        payload.establishment = establishmentId;

        if (state.gapFlag) {
            payload.gapFlag = 1;
        }

        const response = await this._vm.$api.appointments.create(establishmentId, payload);
        commit('SET_APPOINTMENTS', response.data.appointments);

        return response.data.appointments;
    },

    /**
     * @description Fetch the API to get all appointment linked together by the uuid
     * @param commit
     * @param dispatch
     * @param rootGetters
     * @param payload
     * @returns {Q.Promise<never>}
     */
    async fetchGroupOfAppointment({ commit, dispatch, rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        const [apptNumberOrGroupUuid, appointmentDate, uuid, recaptchaToken] = payload;

        const response = await this._vm.$api.appointments.getGroupOfAppointment(
            establishmentId, apptNumberOrGroupUuid, appointmentDate, uuid, recaptchaToken);
        return humps(response.data);
    },

    async sendAppointmentMessage({ commit, dispatch, rootGetters }, payload) {
        const establishmentId = rootGetters['establishment/getEstablishmentId'];
        const [ appointmentId, messageType, configurationMessage ] = payload;

        await this._vm.$api.appointments.sendMessage(
            establishmentId, appointmentId, messageType, configurationMessage
        );
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
